import React from 'react'

const ShortText = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 7C2 6.86739 2.05268 6.74021 2.14645 6.64645C2.24021 6.55268 2.36739 6.5 2.5 6.5H13.5C13.6326 6.5 13.7598 6.55268 13.8536 6.64645C13.9473 6.74021 14 6.86739 14 7C14 7.13261 13.9473 7.25979 13.8536 7.35355C13.7598 7.44732 13.6326 7.5 13.5 7.5H2.5C2.36739 7.5 2.24021 7.44732 2.14645 7.35355C2.05268 7.25979 2 7.13261 2 7ZM2.5 10H10.5C10.6326 10 10.7598 9.94732 10.8536 9.85355C10.9473 9.75979 11 9.63261 11 9.5C11 9.36739 10.9473 9.24021 10.8536 9.14645C10.7598 9.05268 10.6326 9 10.5 9H2.5C2.36739 9 2.24021 9.05268 2.14645 9.14645C2.05268 9.24021 2 9.36739 2 9.5C2 9.63261 2.05268 9.75979 2.14645 9.85355C2.24021 9.94732 2.36739 10 2.5 10Z"
      fill="#71717A"
    />
  </svg>
))
ShortText.displayName = 'ShortText'

export { ShortText }
